import { render } from "./ScoringPromoCode.vue?vue&type=template&id=d0c9c49c"
import script from "./ScoringPromoCode.vue?vue&type=script&lang=js"
export * from "./ScoringPromoCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__